// removed by extract-text-webpack-plugin
module.exports = {"container":"Snackbar__container___3HLJg"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Snackbar/Snackbar.scss
// module id = 1272
// module chunks = 1